import { render } from "./SinglePostView.vue?vue&type=template&id=9757651a"
import script from "./SinglePostView.vue?vue&type=script&lang=js"
export * from "./SinglePostView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__